import {Component, Input} from '@angular/core';

@Component({
	selector: 'dashboard-card',
	templateUrl: './dashboard-card.component.html',
	styleUrls: ['./dashboard-card.component.css']
})
export class DashboardCardWidget {
	@Input() title:string;
	@Input() icon:string;
	@Input() description:string;
	@Input('button-text') buttonText:string;
	@Input() link:string;
}
